import RemoteFilters from 'frontcore/presentation/remote-filters/views/RemoteFilters.vue'
import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import { HSE_RISK } from 'frontend/constants/callers'
import {
  HSE_RISKS_DETAILS_ROUTE_NAME,
  HSE_RISKS_ROUTE_NAME,
} from 'frontend/routes/constants'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const HSERisksList = () => import('frontend/components/hse/HSERisksList')
const HSERisksPage = () => import('frontend/pages/hse/HSERisksPage')
const HSERisksDetailsPage = () => import('frontend/presentation/hse/hse-risk-detail/views/HSERiskDetails')
const HSERisksOverviewPage = () => import('frontend/pages/hse/HSERisksOverviewPage')

export default [
  {
    name: HSE_RISKS_ROUTE_NAME,
    path: '/hse-risks',
    component: HSERisksPage,
    redirect: { name: DASHBOARD_MODULE_TOKENS.hseRisksList.name },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.hseRisksOverview.name,
        components: {
          default: HSERisksOverviewPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          header: { caller: HSE_RISK },
          filters: { caller: HSE_RISK },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: DASHBOARD_MODULE_TOKENS.hseRisksList.name,
        components: {
          default: HSERisksList,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          header: { caller: HSE_RISK },
          filters: { caller: HSE_RISK },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: HSE_RISKS_DETAILS_ROUTE_NAME,
        components: {
          default: HSERisksDetailsPage,
        },
        props: {
          default: (routerInstance) => {
            return {
              riskId: Number(routerInstance.params.id),
              caller: HSE_RISK,
            }
          },
        },
      },
    ],
  },
]
